<template>
  <div>
    <h1 class="text-2xl font-bold text-custom-blue mb-6">Quality Control</h1>
    <QualityControlTab />
  </div>
</template>

<script setup>
import QualityControlTab from '@/views/tabs/lab_tabs/QualityControlTab.vue'
</script>
